import { render, staticRenderFns } from "./ComplaintCloseTrafficModalTemplate.vue?vue&type=template&id=36dd27c4&scoped=true"
import script from "./ComplaintCloseTrafficModalTemplate.vue?vue&type=script&lang=js"
export * from "./ComplaintCloseTrafficModalTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dd27c4",
  null
  
)

export default component.exports